import { render } from "./simpleButton.vue?vue&type=template&id=a645f14a&scoped=true"
import script from "./simpleButton.vue?vue&type=script&lang=js"
export * from "./simpleButton.vue?vue&type=script&lang=js"

import "./simpleButton.vue?vue&type=style&index=0&id=a645f14a&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a645f14a"]])

export default __exports__